import React from 'react';
import { CircleCheckIcon, InfoIcon } from 'lucide-react';
import { instantIntro, instantItems, instantNote } from '../data/content';
import { Highlight } from './Highlight';
export function InstantAccess() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-151" data-mp="1r81cet64og8c">
      <div className="mx-auto grid max-w-5xl gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-16" data-id="element-152" data-mp="1vaoahbte6xdz">
        <div className="text-center lg:text-left" data-id="element-153" data-mp="1hjjecjp8gn8e">
          <h2 className="font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-154" data-mp="1hhykkwaqt8bl">
            What Do You Get <Highlight data-id="element-155" data-mp="17l3osl5utm10">Instantly?</Highlight>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-ink-soft lg:mx-0" data-id="element-156" data-mp="17mojqbw2z6ze">
            {instantIntro}
          </p>
          <p className="mt-6 inline-flex items-start gap-2 rounded-xl bg-paper px-4 py-3 text-left text-xs leading-relaxed text-ink-soft" data-id="element-157" data-mp="ykf7nhl5z5jw">
            <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-royal" aria-hidden="true" data-id="element-158" data-mp="13igpjz6usyts" />
            {instantNote}
          </p>
        </div>

        <ul className="space-y-4" data-id="element-159" data-mp="1w6nv00jev0ce">
          {instantItems.map(item => <li key={item} className="flex items-start gap-4 rounded-2xl border-2 border-ink bg-white px-5 py-5 text-sm font-medium leading-relaxed text-ink shadow-pop sm:text-base" data-id="element-160" data-mp="1s27r24tcy2zt">
              <CircleCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-royal" aria-hidden="true" data-id="element-161" data-mp="213ec8r6yc1ze" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}